module.exports = __webpack_public_path__ + "media/yolo-3.0/yolo_logo_black-b4f3515a.svg";